import { changeCanvasZoom, updateCanvasProportions } from './settings';

const mouseButtons = new Set();

document.body.addEventListener('mousedown', (ev: MouseEvent) => {
	mouseButtons.add(ev.button);

	// Middleclick
	if (ev.button === 1) {
		console.log('middleclick was pressed.');
	}
});

document.body.addEventListener('mouseup', (ev: MouseEvent) => {
	mouseButtons.delete(ev.button);
});

document.body.addEventListener('contextmenu', (ev: MouseEvent) => {
	ev.preventDefault();
});

document.body.addEventListener('wheel', (ev) => {
	const multiplier = ev.deltaY > 0 ? 0.9 : 1.111;

	changeCanvasZoom(multiplier);

	updateCanvasProportions();
});

export function isMouseHeld(button: number): boolean {
	return mouseButtons.has(button);
}

export function setCursor(type: string): void {
	document.body.style.cursor = type;
}
